import { useState } from "react";
import { Select } from "@fidelix/fx-miranda";
import { styled } from "styled-components";
import { matchPath, useLocation, useNavigate } from "react-router-dom";
import { useRequiredParams } from "../utils/url";
import { useCompaniesQuery } from "./company.queries";
import { setCompanyToLocalStorage } from "../helper";

export function CompanySelect() {
  const { companyId } = useRequiredParams({ companyId: "string" });
  const { data: companies = [] } = useCompaniesQuery();
  const [selectedCompany, setSelectedCompany] = useState(companyId);
  const navigate = useNavigate();
  const location = useLocation();

  function handleSelect(value: string | number | null) {
    if (!value) {
      return;
    }
    setCompanyToLocalStorage(value);
    const match = matchPath("/company/:companyId/*", location.pathname);
    const route = match?.params["*"] || "dashboard";
    setSelectedCompany(String(value));
    navigate(`/company/${value}/${route}`);
  }

  return (
    <NavSelect
      key={selectedCompany}
      isFilterable={true}
      data-test-id="company-select"
      aria-label="Companies"
      placeholder={
        companies.find((c) => c.id === Number(selectedCompany))?.name || ""
      }
      selected={selectedCompany}
      onSelect={handleSelect}
      maxHeight="350px"
    >
      {companies.map((company) => (
        <Select.Option key={company.id} value={String(company.id)}>
          {company.name}
        </Select.Option>
      ))}
    </NavSelect>
  );
}

const NavSelect = styled(Select)`
  flex-shrink: 1;
  min-width: 100px;
  width: 300px;
  button {
    background-color: ${(p) => p.theme.colors.white};
  }
`;
